/* PartHeaderComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PartHeaderRenderer");
const _ = require("lodash");

class PartHeaderComponent extends EventEmitter {
    constructor(configOptions) {
        super();
        this._title = _.get(configOptions, "title", "");
        this._partIcon = _.get(configOptions, "iconRepoName", "");
        this._quadrantName = _.get(configOptions, "quadrantName", "default");
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        return prom;
    }

    toJSON() {
        let JSONObj = {};
        return JSONObj;
    }

    fromJSON() {}

    updateFromJSON() {}

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */

    /*******************************************/
    _closeButtonClicked() {
        this.emit("closeClicked");
    }

    /*
  _doubleClicked(){
      this.emit('dblclick');
  }
  */
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */

    /*******************************************/
    get partIcon() {
        return this.getPartIcon();
    }

    set partIcon(iconComponent) {
        this.setPartIcon(iconComponent);
    }

    getPartIcon() {
        return this._partIcon;
    }

    setPartIcon(iconComponent) {
        this._partIcon = iconComponent;
        this.emit("partIconChanged");
        return this;
    }

    get title() {
        return this.getTitle();
    }

    set title(titleString) {
        this.setTitle(titleString);
    }

    getTitle() {
        return this._title;
    }

    setTitle(titleString) {
        this._title = titleString;
        this.emit("titleChanged");
        return this;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = PartHeaderComponent;
